import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLine } from '@fortawesome/free-brands-svg-icons';
import {
  FaLine,
  FaInstagram,
  FaFacebookSquare,
  FaYoutube,
  FaMapMarkedAlt,
  FaTwitterSquare,
} from "react-icons/fa";
import s from './Footer.module.scss';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <div className={"row mt-5 pt-4 border-top"}>
      <div className={"col-12"}>
        <div className={s.titleSection}>
          <div className={s.titleContainer}>
            <span>Connect with Us</span>
            <h2>まずは聞いてみる</h2>
          </div>
        </div>
        <div className={s.container}>
          <div className={s.logoSection}>
            <img className={s.logo} src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/banner-line-1.png" alt="" />
            <button
              className={s.vcBtnLine}
              onClick={() => window.open('https://line.me/R/ti/p/%40dii1064j', '_blank')}
            >
              <FontAwesomeIcon icon={faLine} size="lg" /> LINEで相談する
            </button>
          </div>
          <div className={s.right}>
            <div className={s.details}>
              <div className={s.flex}>
                <h3>ジェイさんの楽しい日本語ツアー</h3>


              </div>
              <div className={s.flex}>

                <FaMapMarkerAlt />
                <span>78 Scott St, Bungalow QLD 4870</span>
              </div>
              <div className={s.flex}>
                <FaPhoneAlt />
                <span>+61-7-4041-2583</span>
              </div>
              <div className={s.flex}>
                <FaEnvelope />
                <span>booking@mightyaussie.com</span>
              </div>
            </div>
            <div className={s.times}>
              <span>受付時間</span>
              <span>日本時間：7:00〜18:00</span>
              <span>現地時間：8:00〜19:00</span>
            </div>
            <p className={s.text}>ケアンズを中心としたオーストラリア現地ツアーのご紹介をしております。大手代理店より安く、アットホームで大満足いただけるサービスで「ジェイさんツアーで良かった！」と言われるように毎日奮闘中です。</p>
        </div>
      </div>
      <div>
        </div>
        <div>
      </div>
      <div className={s.bottom}>
        <div className={s.menu}>
          <ul>
            <li><a href="/faqs">よくある質問</a></li>
            <li><a href="/contact">お問い合わせと会社情報</a></li>
            <li><a href="/term">初めての方へ（予約規定など）</a></li>
            <li><a href="/privacy">個人情報保護方針</a></li>
          </ul>
          <div className={s.logos}>
            <a href="https://line.me/R/ti/p/%40dii1064j" target="_blank" rel="noopener noreferrer">
              <FaLine size={48} />
            </a>
            <a href="https://www.instagram.com/mightyaussie/" target="_blank" rel="noopener noreferrer">
              <FaInstagram size={48} />
            </a>
            <a href="https://www.facebook.com/Jaysantour/" target="_blank" rel="noopener noreferrer">
              <FaFacebookSquare size={48} />
            </a>
            <a href="https://www.youtube.com/watch?time_continue=1&v=N2Tlrvglew0" target="_blank" rel="noopener noreferrer">
              <FaYoutube size={48} />
            </a>
            <a href="https://goo.gl/maps/QCfNnfCCe8s" target="_blank" rel="noopener noreferrer">
              <FaMapMarkedAlt size={48} />
            </a>
            <a href="https://twitter.com/JsanTour55" target="_blank" rel="noopener noreferrer">
              <FaTwitterSquare size={48} />
            </a>
          </div>
        </div>
        <div className={s.rights}>© Mighty Aussie Adventures Pty Ltd.</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
